import { useEffect,useState } from "react";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import Lodder from "../../../components/Lodder";
import servicesService from "../../../services/ServicesService";
import PaymentService from "../../../services/PaymentService";
import { ThreeDots } from "react-loader-spinner";
import { notification } from "antd";
import { useNavigate ,useParams} from "react-router-dom";
import customerServices from "../../../services/CustomerService";
import html2pdf from "html2pdf.js/dist/html2pdf.min";
import ReactDOMServer from "react-dom/server";
import MultiMemberLLCAgreement from "./MultiMemberLLCAgreement";
import CryptoJS from "crypto-js";
const fieldStyles = {
  border: "1px solid #dee2e6",
  "border-radius": "0.25rem",
  color: "rgb(26, 32, 44)",
  "font-weight": 400,
  height: "38px",
  width: "100%",
  "font-size": "14px",
  padding: "6px 12px",
};
export default function MultiMemberLLCPayment() {
  
// #region Initilization
const navigate = useNavigate();
const [name, setName] = useState("");
const [feild, setFeild] = useState(true);
const [amount, setAmount] = useState(550);
const [paymentToken, setPaymentToken] = useState(null);
const [fieldState, setFeildState] = useState(null);
const [showLodder, setShowLodder] = useState(false);

// #endregion
  // #region Other Helper Function
  const userData = useParams().userData;
  const decryptedData = CryptoJS.AES.decrypt(
    decodeURIComponent(userData),
    process.env.REACT_APP_SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);
  const customer = JSON.parse(decryptedData);
  const handleBack=()=>{
    const encryptedUserData = CryptoJS.AES.encrypt(
        JSON.stringify(customer),
        process.env.REACT_APP_SECRET_KEY
      ).toString();
      const userData = encodeURIComponent(encryptedUserData);
    navigate(`/MultiMemberOnboarding/${userData}`)
  }
  // #endregion

  // #region Payment
  const handleChange = (change) => {
    setFeildState(change.state);
  };
  window.gravityLegal.addChangeListener((event) => {
    console.log(event);
    if (event.type === "fields_loaded") {
      setFeild(false);
    }
    handleChange(event);
  });
  
 
  const handleAddCustomerSubmit = () => {
    // eslint-disable-next-line no-restricted-globals
    event.preventDefault();
    if (fieldState.initializing) {
      setShowLodder(false);
      return;
    }
    window.gravityLegal.submitFields(async (err) => {
      setShowLodder(true);
      if (err) {
        notification.error({
          message: `${err.fieldId} ${err.result}`,
        });
        setShowLodder(false);
        return;
      }
      fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
          setShowLodder(true);
          const ipAddress = data.ip;
          customer.ip = ipAddress;
          const printElement = ReactDOMServer.renderToString(
            MultiMemberLLCAgreement(customer)
          );
          const opt = {
            margin: [13, 0],
          };
          const pdf = html2pdf().from(printElement).set(opt);
          pdf
            .toPdf()
            .outputPdf("blob")
            .then((PDF) => {
              /* customer.file=PDF */
              customer.amount = amount;
              customer.paymentMethod = fieldState.paymentMethod;
              customer.paymentToken = paymentToken;
              customer.signature=customer.signature.split(",")[1]
              customer.serviceId=1032
              customerServices.RegisterCustomer(customer, PDF)
                .then((response) => {
                  if (response.status) {
                    const customerCredentials = {
                      email: customer.email,
                      password: customer.password,
                    };
                    customerServices.LoginCustomer(customerCredentials)
                      .then((response) => {
                        localStorage.setItem(
                          "accessToken",
                          response.resultData.token
                        );
                        localStorage.setItem("pop", "1");
                        navigate("/dashboard");
                      })
                      .catch((error) => {
                        setShowLodder(false);
                        notification.error({
                          message: error.response.data.Message,
                        });
                        setShowLodder(false);
                      });
                  }
                })
                .catch((error) => {
                  setShowLodder(false);
                  console.log(error);
                });
            });
        })
        .catch((error) => {
          setShowLodder(false);
          console.error("Error fetching IP address:", error);
        });
    });
  };
  // #endregion
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Foundry Law - Multi-Member LLC Payment Process";
    PaymentService.CreatePaymentToken().then((response) => {
        setPaymentToken(response);
      });
      servicesService.GetServiceByServiceName(1032)
      .then((response) => {
        if (response.status) {
          setAmount(Math.floor(response.resultData.price))
        }
      })
      .catch((error) => {
        notification.error({
          message: error,
        });
      })
  }, []);
  useEffect(() => {
    // Initialize the payment form when the payment token is available
    if (paymentToken) {
      window.gravityLegal.init({
        paymentToken,
        activeForm: "card",
        fields: {
          cardNumber: {
            containerId: "card-number",
            style: fieldStyles,
          },
          cardExpirationDate: {
            containerId: "card-exp",
            style: fieldStyles,
          },
          cardSecurityCode: {
            containerId: "card-cvv",
            style: fieldStyles,
          },
        },
      });
    }
  }, [paymentToken]);
  return (
    <>
      <Header />
      <Lodder show={showLodder} />
      <main>
        <div className="my-5 pt-5 login-form ">
          <div className="mx-auto payment-card card mt-2 border-0 shadow mt-4">
            <div className="container card-body ">
              <div className="row">
                <div className="col-12">
                  <figure className="text-center mx-auto mb-0">
                    <img
                      src="/logo.png"
                      className="img-fluid"
                      alt="foundary logo"
                      style={{ width: 60 }}
                    />
                  </figure>
                  <h5 className="card-title mt-3 text-center mb-3 w-100">
                    Payment Process
                  </h5>
                </div>
              </div>
            </div>
            <div
              className="p-2 text-center"
              style={{ backgroundColor: "rgb(234, 103, 35)" }}
            >
              <p className="payment-heading">Payment Amount</p>
              <p className="payment-title">${amount}.00</p>
            </div>
            <div className="container">
              <div className="row card-payment">
                <div className="col-12">
                  <form className="row">
                    <div className="mb-3 col-lg-12">
                      <label className="form-label">Name on card</label>
                      <input
                        className="form-control rounded-1"
                        type="text"
                        value={name}
                        onChange={(event) => {
                          if (
                            event.target.value.length === 1 &&
                            event.target.value[0] === " "
                          ) {
                            setName("");
                            return;
                          }
                          setName(event.target.value);
                        }}
                        placeholder="NAME ON THE CARD"
                      />
                    </div>
                    <div className="mb-3 col-lg-12">
                      <label className="form-label">Card number</label>
                      {/* <input className="form-control rounded-1" type="text" /> */}
                      <div className="payment-input" id="card-number">
                        <ThreeDots
                          visible={feild}
                          height="20"
                          width="50"
                          color="rgb(234, 103, 35)"
                          radius="9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </div>
                    <div className="mb-3 col-lg-6">
                      <label className="form-label">Expiration date</label>
                      {/* <input className="form-control rounded-1" type="text" /> */}
                      <div className="payment-input" id="card-exp">
                        <ThreeDots
                          visible={feild}
                          height="20"
                          width="50"
                          color="rgb(234, 103, 35)"
                          radius="9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </div>
                    <div className="mb-3 col-lg-6">
                      <label className="form-label">CVV</label>
                      {/* <input className="form-control rounded-1" type="text" /> */}
                      <div className="payment-input" id="card-cvv">
                        <ThreeDots
                          visible={feild}
                          height="20"
                          width="50"
                          color="rgb(234, 103, 35)"
                          radius="9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </div>
                    <div className="border-0 text-center d-flex justify-content-end mt-3 mb-2">
                      <button
                        type="submit"
                        className=" btn btn-submit-secondary d-block  w-100 me-2"
                        onClick={handleBack}
                      >
                        BACK
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary d-block submit-button w-100"
                        onClick={handleAddCustomerSubmit}
                        /* onClick={handlePaymentSubmit} */
                      >
                        COMPLETE PAYMENT AND SUBMIT
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
